import React, { useState, useEffect } from 'react';
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  CardHeader,
  Nav,
  NavItem,
  NavLink,
  TabContent,
  TabPane,
  Input,
  Label,
  Button,
  Alert,
} from 'reactstrap';
import { useDispatch, useSelector } from 'react-redux';
import classnames from 'classnames';

import { getSalesByProvider, getSalesBySeller } from '../../redux/actions/sales';
import ProviderSalesTab from './ProviderSalesTab';
import SellerSalesTab from './SellerSalesTab';

const Sales = () => {
  const dispatch = useDispatch();
  const [activeTab, setActiveTab] = useState('provider');
  const [startDate, setStartDate] = useState('');
  const [endDate, setEndDate] = useState('');
  const [isFetching, setIsFetching] = useState(true);

  const providerState = useSelector((state) => state.sales.byProvider);
  const sellerState = useSelector((state) => state.sales.bySeller);

  useEffect(() => {
    dispatch(getSalesByProvider('', ''));
    dispatch(getSalesBySeller('', ''));
  }, [dispatch]);

  useEffect(() => {
    if (providerState && sellerState) {
      setIsFetching(false);
    }
  }, [providerState, sellerState]);

  const handleFilter = () => {
    setIsFetching(true);
    dispatch(getSalesByProvider(startDate, endDate));
    dispatch(getSalesBySeller(startDate, endDate));
  };

  const providerError =
    providerState?.status === 'danger' ? providerState.message : null;
  const sellerError =
    sellerState?.status === 'danger' ? sellerState.message : null;

  return (
    <Container fluid className="p-4">
      <h4 className="mb-4">Ventas</h4>

      <Card className="mb-4">
        <CardBody>
          <Row>
            <Col md={3}>
              <Label for="startDate">Fecha inicio</Label>
              <Input
                type="date"
                id="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Col>
            <Col md={3}>
              <Label for="endDate">Fecha fin</Label>
              <Input
                type="date"
                id="endDate"
                value={endDate}
                onChange={(e) => setEndDate(e.target.value)}
              />
            </Col>
            <Col md={3} className="d-flex align-items-end">
              <Button color="primary" onClick={handleFilter} disabled={isFetching}>
                {isFetching ? 'Cargando...' : 'Filtrar'}
              </Button>
            </Col>
          </Row>
        </CardBody>
      </Card>

      <Card>
        <CardHeader>
          <Nav tabs className="card-header-tabs">
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'provider' })}
                onClick={() => setActiveTab('provider')}
                style={{ cursor: 'pointer' }}
              >
                Por Proveedor
              </NavLink>
            </NavItem>
            <NavItem>
              <NavLink
                className={classnames({ active: activeTab === 'seller' })}
                onClick={() => setActiveTab('seller')}
                style={{ cursor: 'pointer' }}
              >
                Por Vendedor
              </NavLink>
            </NavItem>
          </Nav>
        </CardHeader>
        <CardBody>
          <TabContent activeTab={activeTab}>
            <TabPane tabId="provider">
              {providerError && (
                <Alert color="danger">{providerError}</Alert>
              )}
              <ProviderSalesTab
                data={providerState?.data}
                loading={isFetching && !providerError}
              />
            </TabPane>
            <TabPane tabId="seller">
              {sellerError && (
                <Alert color="danger">{sellerError}</Alert>
              )}
              <SellerSalesTab
                data={sellerState?.data}
                loading={isFetching && !sellerError}
              />
            </TabPane>
          </TabContent>
        </CardBody>
      </Card>
    </Container>
  );
};

export default Sales;
